
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';

import Routes from './common/client/components/Routes';

import Analyze2OpsubPage from './pages/analyze2opsub/Analyze2OpsubPage';
import AnalyzeDefunctParPage from './pages/analyzeDefunctPar/AnalyzeDefunctParPage';
import AnalyzeVlaPage from './pages/analyzeVla/AnalyzeVlaPage';
import App from './components/App';
import HomePage from './pages/home/HomePage';
import IsknActualInfoPage from './pages/isknActualInfo/IsknActualInfoPage';
import IsknExplorerPage from './pages/isknExplorer/IsknExplorerPage';
import LoggedPage from './pages/auth/LoggedPage';
import LoginPage from './pages/auth/LoginPage';
import LogoutPage from './pages/auth/LogoutPage';
import NoAccessPage from './pages/auth/NoAccessPage';
import ProjectOverviewPage from './pages/projectOverview/ProjectOverviewPage';
import ProjectListPage from './pages/projectList/ProjectListPage';

const routes = [
    {
        component: App,
        routes: [{
            path: '/login',
            component: LoginPage
        }, {
            path: '/logout',
            component: LogoutPage
        }, {
            path: '/noaccess',
            component: NoAccessPage
        }, {
            component: LoggedPage,
            routes: [{
                path: '/',
                exact: true,
                component: HomePage
            }, {
                path: '/analyze2opsub/:id',
                component: Analyze2OpsubPage
            }, {
                path: '/analyzeDefunctPar/:id',
                component: AnalyzeDefunctParPage
            }, {
                path: '/analyzeVla/:id',
                component: AnalyzeVlaPage
            }, {
                path: '/isknexplorer/:id',
                component: IsknExplorerPage
            }, {
                path: '/isknActualInfo/:id',
                component: IsknActualInfoPage
            }, {
                path: '/projectview/:id',
                component: ProjectOverviewPage
            }, {
                path: '/projectlist',
                component: ProjectListPage
            }]
        }]
    }
];

const AppRouter = () => {
    return (
        <Router>
            <Routes routes={routes} />
        </Router>
    );
}

export default AppRouter;
